import saveAs from 'file-saver';

export const saveFile = (data: Blob, filename: string) => {
  saveAs(data, filename);
};
